import React from 'react';

const FLAG_STYLES: Record<string, { label: string; className: string }> = {
  // Synthetic match-status badges, derived per task.
  matched: { label: 'Matched', className: 'bg-green-100 text-green-800' },
  partially_matched: { label: 'Partially matched', className: 'bg-amber-100 text-amber-800' },
  not_processed: { label: 'Not processed', className: 'bg-gray-100 text-gray-500' },
  no_match: { label: 'No Match', className: 'bg-red-100 text-red-800' },
  missing_candidate: { label: 'Missing Candidate', className: 'bg-orange-100 text-orange-800' },
  multiple_similar_candidates: {
    label: 'Multiple Similar Candidates',
    className: 'bg-yellow-100 text-yellow-800',
  },
  duplicate_candidate: { label: 'Duplicate Candidate', className: 'bg-purple-100 text-purple-800' },
  wrong_sequence: { label: 'Wrong Sequence', className: 'bg-red-100 text-red-800' },
};

export const PogResetFlagBadge: React.FC<{ flag: string; suffix?: string }> = ({
  flag,
  suffix,
}) => {
  const style = FLAG_STYLES[flag] ?? { label: flag, className: 'bg-gray-100 text-gray-800' };
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.className}`}
    >
      {style.label}
      {suffix ? ` ${suffix}` : ''}
    </span>
  );
};

export const PogResetFlagBadges: React.FC<{ flags: string[] }> = ({ flags }) => {
  if (flags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {flags.map((flag) => (
        <PogResetFlagBadge key={flag} flag={flag} />
      ))}
    </div>
  );
};
